import { getLocaleDecimalSeparator } from '#helper';

export const outputFormatOptions = {
  PDF: 'pdf',
  CSV: 'csv'
};

const buildPDFReportPath = (
  {
    shipmentId,
    token,
    measurementSystem,
    selectedContentOptions,
    selectedFileIds
  }
) => {
  const contentOptionToQueryParameter = {
    locations: 'includeLocations',
    timeline: 'includeTimeline',
    statisticalSummary: 'includeStatistics',
    measurementsTable: 'includeMetrics',
    temperatureChart: 'temperature',
    humidityChart: 'humidity',
    cargo: 'includeCargo',
    customFields: 'includeCustomFields'
  };

  const chartsOptions = {
    temperatureChart: 'temperature',
    humidityChart: 'humidity'
  };

  const chartsParams = [];

  const query = new URLSearchParams({
    measurementSystem
  });

  if (selectedFileIds?.length > 0) {
    query.set('fileIds', selectedFileIds);
  }

  Object.entries(contentOptionToQueryParameter).forEach(([option, parameter]) => {
    if (selectedContentOptions[option]) {
      if (chartsOptions[option]) {
        chartsParams.push(parameter);
      } else {
        query.set(parameter, true);
      }
    }
  });

  if (chartsParams.length) {
    query.set('includeCharts', chartsParams);
  }

  return `report-external/${token ? 'deeplink/' : ''}shipment/${token || shipmentId}?${query.toString()}`;
};

const buildCSVReportPath = ({
  shipmentId,
  token,
  measurementSystem
}) => {
  const query = new URLSearchParams({
    system: measurementSystem
  });

  const decimalSeparator = getLocaleDecimalSeparator();

  if (decimalSeparator === ',') {
    query.set('decimalSeparator', 'comma');
  }

  return `report/${token ? 'deeplink/' : ''}csv/shipment/${token || shipmentId}?${query.toString()}`;
};

const buildReportPath = ({
  outputFormat,
  token,
  measurementSystem,
  shipmentId,
  contentOptions,
  fileOptions
}) => {
  const selectedContentOptions = Object.fromEntries(
    contentOptions.map(({ name, checked }) => [name, checked])
  );
  const selectedFileIds = fileOptions?.reduce(
    (acc, { id, checked }) => {
      if (checked) {
        acc.push(id);
      }
      return acc;
    },
    []
  );

  if (outputFormat === outputFormatOptions.CSV) {
    return buildCSVReportPath({
      shipmentId,
      token,
      measurementSystem
    });
  }

  return buildPDFReportPath({
    shipmentId,
    token,
    measurementSystem,
    selectedContentOptions,
    selectedFileIds
  });
};

export default buildReportPath;
